// extracted by mini-css-extract-plugin
export default {"root":"_1xGBoevf","logo":"_39oq4P6F","link":"_1k34zDiH"};